import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Navigation } from 'react-router';
import { logout } from 'actions/authActions';

const Logout = React.createClass({

  propTypes: {
    logout: PropTypes.func.isRequired
  },
  contextTypes: {
    userId: PropTypes.string.isRequired
  },

  mixins: [ Navigation ],

  componentDidMount () {
    const {userId} = this.context;
    this.props.logout({userId});
  },

  render () {
    return <p>You are now logged out</p>;
  }

});

export default connect(
  null,
  { logout }
)(Logout);



// WEBPACK FOOTER //
// ./src/views/auth/logout.jsx